module.exports = __webpack_public_path__ + "img/ch17_05_烫金邀请.03b5547b.jpg";